// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/Auth/Login';
import StylingWebsite from './pages/StylingWebsite';
import Dashboard from './components/Dashboard';
import CapsuleViewer from './components/CapsuleViewer';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<StylingWebsite />} />
          <Route path="/capsule/:id" element={<CapsuleViewer />} />
          
          {/* Protected dashboard routes */}
          <Route path="/dashboard/*" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          {/* Catch all route - redirect to home */}
          <Route path="*" element={<StylingWebsite />} />
          
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;